import intlTelInput from 'intl-tel-input';
import IMask from 'imask';
import { isNullOrEmpty } from './isNullOrEmpty';
import { inicializarInternacionalizacao } from "../localizacao/configurarTelefoneInput/configurarTelefoneInput";
import i18next from "i18next";

const validacaoTelefones = (telefoneID, celularID) => {
    const celularElement = document.getElementById(celularID);
    const telefoneElement = document.getElementById(telefoneID);

    return !isNullOrEmpty(telefoneElement.value) || !isNullOrEmpty(celularElement.value);
};

const gerarRegrasValidacao = (numeroAdicionalID,required, inputElement) => {
    const regrasValidacao = [
        {
            rule: 'minLength',
            value: 14,
            errorMessage: i18next.t('ErroNumeroIncompleto'),
        },
    ];

    if(!isNullOrEmpty(numeroAdicionalID))
        regrasValidacao.push({validator: () => {return validacaoTelefones(inputElement.id, numeroAdicionalID)}, errorMessage: i18next.t('ErroPeloMenosUmNumero')});
    
    if(required)
        regrasValidacao.push({ rule: "required", errorMessage: i18next.t('FormValidationTelefoneRequired')});

    return regrasValidacao;
};

const AddMaskByDialCode = (inputIntlTel, inputElement, validateElement, containerID, numeroAdicionalID, required) => {
    const brasilDialCode = '55';
    let currentDialCode = inputIntlTel.getSelectedCountryData().dialCode;
    let mask = null;

    const regrasValidacao = gerarRegrasValidacao(numeroAdicionalID, required, inputElement);

    const aplicarMascaraBrasil = () => {
        if (mask) mask.destroy();

        mask = IMask(inputElement, {
            mask: [
                { mask: "(00) 0000-0000" },
                { mask: "(00) 00000-0000" }
            ]
        });

        validateElement.addField(inputElement, regrasValidacao, {errorsContainer: document.getElementById(containerID)});
    };

    const removerMascaraBrasil = () => {
        if (mask) mask.destroy();

        validateElement.removeField(inputElement);

        const regrasSemMinLength = regrasValidacao.filter(regra => regra.rule !== 'minLength');

        if (regrasSemMinLength.length > 0) 
            validateElement.addField(inputElement, regrasSemMinLength, {errorsContainer: document.getElementById(containerID)});
    };

    const aplicarMascaraPorCodigo = (dialCode) => {
        if (dialCode === brasilDialCode) 
            aplicarMascaraBrasil();
        else 
            removerMascaraBrasil();
    };

    aplicarMascaraPorCodigo(currentDialCode);

    inputElement.addEventListener("countrychange", () => {
        currentDialCode = inputIntlTel.getSelectedCountryData().dialCode;
        aplicarMascaraPorCodigo(currentDialCode);
    });

    return mask;
};


export function configurarTelefoneInput(inputNumeroElement, JustaValidateObject, containerID = "container-numero", numeroAdicionalID = "", required = false) {
    inicializarInternacionalizacao();

    const opcoesIntlInput = {
        initialCountry: 'br',
        preferredCountries: ['br', 'cl', 'ar', 'es', 'pt', 'us', 'fr'],
        dropdownContainer: document.body,
        formatOnDisplay: false,
        autoPlaceholder: "aggressive",
        utilsScript: '/assetsV2/lib/intl-tel-util/utils.js',
    };

    let inputNumeroIntlTel = intlTelInput(inputNumeroElement, opcoesIntlInput);
    const inputNumeroMask = AddMaskByDialCode(inputNumeroIntlTel, inputNumeroElement,JustaValidateObject, containerID, numeroAdicionalID, required);

    return {numeroIntlTel: inputNumeroIntlTel, numeroMask: inputNumeroMask}

}

